import { createAsyncThunk } from "@reduxjs/toolkit";
import { TServiceError } from "types/general";
import { getAssetDashboardReviews } from "api/getAssetDashboardReviews";
import { REVIEWS_SLICE_NAME } from "./constants";
import { IReviewsResponse } from "./types";

export const fetchReviews = createAsyncThunk<
  IReviewsResponse,
  string,
  { rejectValue: TServiceError }
>(
  `${REVIEWS_SLICE_NAME}/fetchReviews`,
  async (propertyId, { rejectWithValue }) => {
    try {
      return await getAssetDashboardReviews(propertyId);
    } catch (err) {
      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);
